/**
 * Auto-resizes with DataGrid layout changes (e.g., column hide/show).
 * Returns a plain object (not CSSProperties) so it can be spread
 * into both MUI sx props and tss-react makeStyles without type errors.
 */
export function createClampStyles(numLines: number) {
  return {
    WebkitBoxOrient: 'vertical' as const,
    WebkitLineClamp: numLines,
    display: '-webkit-box' as const,
    overflow: 'hidden' as const,
    whiteSpace: 'normal' as const,
    wordBreak: 'break-word' as const,
  };
}
